import produce from "immer";
import { FETCH_SOCIETY_INFO_SUCCESS } from "src/actions/societyAction";

const initialState = {
  societyInfo: [],
};

const societyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SOCIETY_INFO_SUCCESS: {
      const { societyInfo } = action.payload;

      return produce(state, (draft) => {
        draft.societyInfo = societyInfo;
      });
    }

    default: {
      return state;
    }
  }
};

export default societyReducer;